import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import * as MuiIcons from "@mui/icons-material";

const StatusFilterChips = ({ statuses, statusCounts, activeFilters, onToggle }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" fontWeight="bold" mb={1}>
        Filter by Status
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {statuses.map((s) => {
          const Icon = MuiIcons[s.icon] || MuiIcons.InfoOutlined;
          const count = statusCounts[s.statusname?.toLowerCase()] || 0;
          const isActive = activeFilters.includes(s.statusname);
          const color = s.color || "default";

          return (
            <Chip
              key={s.id}
              label={`${s.statusname.toUpperCase()} (${count})`}
              icon={<Icon />}
              onClick={() => onToggle(s.statusname)}
              variant={isActive ? "filled" : "outlined"}
              sx={{
                cursor: "pointer",
                fontWeight: "bold",
                ...(isActive
                  ? {
                      color: "#fff",
                      backgroundColor: (theme) =>
                        theme.palette[color]?.main || color,
                    }
                  : {
                      "&:hover": {
                        backgroundColor: (theme) =>
                          theme.palette[color]?.main || "#eee",
                        color: "#fff",
                      },
                    }),
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default StatusFilterChips;
